import "./App.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import PublicRoutesCheck from "./App/Utilities/Routes/PublicRoutes";
import PrivateRoutesCheck from "./App/Utilities/Routes/PrivateRoutes";
import Dashboard from "./App/Components/Pages/Dashboard/Dashboard";
import Login from "./App/Components/Authentication/Login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { ROUTES } from "./App/Utilities/Constants/Constants";
import { PrivateRoutes, PublicRoutes } from "./App/Utilities/Routes/Routes";
import Loader from "./App/Shared/Loader/Loader";
import { useEffect } from "react";
import { applyUserBasedTheme } from "./App/Services/Helpers/Helper";

function App() {
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  useEffect(()=>{
    applyUserBasedTheme();
  },[]);

  return (
    <>
      <Loader />
      <ToastContainer rtl={language === "English" ? false : true} />
      <Routes>
        <Route
          path=""
          element={
            <>
              <Navigate to={ROUTES.DASHBOARD} />
            </>
          }
        ></Route>
        <Route element={<PublicRoutesCheck />}>
          <Route path="/" element={<Login />}></Route>
          {PublicRoutes.map((routes: any, index: any) => {
            return (
              <Route
                key={index}
                path={routes.path}
                element={routes.component}
              ></Route>
            );
          })}
        </Route>
        <Route element={<PrivateRoutesCheck />}>
          <Route path="/" element={<Dashboard />}></Route>
          {PrivateRoutes.map((routes: any, index: any) => {
            return (
              <Route
                key={index}
                path={routes.path}
                element={routes.component}
              ></Route>
            );
          })}
          <Route path="*" element={<Dashboard />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
